import { checkBeforeEnter } from "@/auth/utils";

export default [
  {
    path: "/evaluations",
    name: "evaluations-list",
    component: () =>
      import(
        "@/views/modules/evaluations/evaluations-list/EvaluationsList.vue"
      ),
    beforeEnter: (to, from, next) => {
      checkBeforeEnter(["superadmin", "admin"], to, from, next);
    },
    meta: {
      resource: "ACL",
      pageTitle: "Formularios",
      breadcrumb: [
        {
          text: "Lista de formularios por periodo",
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
];
